import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { navigateToSection } from '../utils/helpers';

import {
	IconClock, IconPhone, IconLetterX, IconBrandApple, 
	IconBrandGooglePlay, IconBrandFacebook, IconShoppingCart, 
	IconBrandInstagram, IconBrandYoutube
} from '@tabler/icons-react';

const Menu = () => {
	const navigate = useNavigate();
	const location = useLocation();

    return (
        <div className="menu">
            <ul className="menu-items">
                <li className="nav-item" onClick={() => navigateToSection('home', navigate, location, 60)}>
                    <span className="nav-link">ACASA</span>
                </li>
                <li className="nav-item" onClick={() => navigateToSection('about', navigate, location, 80)}>
                    <span className="nav-link">DESPRE</span>
                </li>
                <li className="nav-item" onClick={() => navigateToSection('testimonial', navigate, location, -130)}>
                    <span className="nav-link">RECENZII</span>
                </li>
                <li className="nav-item" onClick={() => navigateToSection('contact', navigate, location)}>
                    <span className="nav-link">CONTACT</span>
                </li>
            </ul>
        </div>
    );
}

const Header = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1200);
	const navigate = useNavigate();
	const location = useLocation();

	const handleRequestClick = () => {
		navigateToSection('request', navigate, location);
	};

	const goToSection = (e, sectionId, offset = 0) => {
		e.preventDefault();
		setSidebarOpen(false);
		navigateToSection(sectionId, navigate, location, offset);
	};

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 1200);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="container-fluid p-0">
            <div className="topbar">
                <div className="banner">
                    <div className="row align-items-center">
          
                        <div className="col-lg-4">
                            <div className="info">
                                <div className="item left">
                                    <a href="/" onClick={(e) => goToSection(e, 'contact')} aria-label="Program de lucru">
                                        <IconClock stroke={1.6} size={35}/>
                                        <span>
                                            <small>Relatii clienti:</small> Luni - Vineri : 07:00 - 18:00
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="motto">
                                THE QUALITY IS HERE
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="info">
                                <div className="item right">
                                    <a href="tel:+40723531203" aria-label="Suna-ne">
                                        <span>
                                            <small>Numar Telefon</small> +40 723 531 203
                                        </span>
                                        <IconPhone stroke={1.6} size={35}/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="navbar">

                    <div className="col-xl-3 col-lg-2 col-md-6 col-6">
                        <div className="logo">
                            <a href="/" onClick={(e) => goToSection(e, 'home', 60)} aria-label="Acasa">
                                <img src="./images/logo.webp" alt="Navbar Logo"/>
                            </a>
                        </div>
                    </div>

                    <div className="col-xl-9 col-lg-10 col-md-6 col-6 align-items-center d-flex justify-content-end">
                        {!isMobileView && ( 
                            <Menu/>
                        )}
                        
                        <div className="toggle d-flex align-items-center justify-content-end">
                            <button onClick={() => setSidebarOpen(!isSidebarOpen)} aria-label="Toggle">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>

                        <div className="request">
                            <button className="btn effect" onClick={handleRequestClick}>Solicit Oferta</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="sidebar">
                <div className={`container ${isSidebarOpen ? 'active' : '' }`}>

                    <button className="close" onClick={() => setSidebarOpen(!isSidebarOpen)} aria-label="Close">
                        <IconLetterX style={{ color: 'black' }} stroke={2.5} size={20}/>
                    </button>

                    <div className="logo">
                        <a href="/" onClick={(e) => goToSection(e, 'home', 60)} aria-label="Acasa">
                            <img src="./images/logo.webp" alt="Sidebar Logo"/>
                        </a>
                    </div>

                    {isMobileView ? ( 
                        <Menu/>
                    ) : (
                        <div className="placeholder text-center mt-4">
                            <h3>PIESE AUTO DE INCREDERE</h3>
                            <p>
                                Bun venit la partenerul tau de incredere in piese auto! 
                                Toate componentele noastre sunt testate si garantate pentru o buna fiabilitate.
                            </p>
                        </div>
                    )}

                    <div className="bottom">
                        <div className="mobile-store mb-4 mt-3">
                            <h6 className="text-center">Descarca acum aplicatia, disponibila pe Android sau iOS</h6>
                            <div>
                                <a className="download" href="#" onClick={(e) => e.preventDefault()} aria-label="Descarca din Apple Store">
                                    <span>
                                        <IconBrandApple stroke={1.5} size={35}/>
                                    </span>
                                    <strong>
                                        <small>available on</small> Apple Store
                                    </strong>
                                </a>
                            </div>

                            <div>
                                <a className="download" href="#" onClick={(e) => e.preventDefault()} aria-label="Descarca din Google Play">
                                    <span>
                                        <IconBrandGooglePlay stroke={1.5} size={35}/>
                                    </span>
                                    <strong>
                                        <small>available on</small> Google Play
                                    </strong>
                                </a>
                            </div>
                        </div>

                        <div className="social-media mt-1">
                            <div>
                                <a href="#">
                                    <span>
                                        <IconBrandYoutube stroke={1.4} size={24}/>
                                    </span>
                                </a>
                            </div>
                            <div>
                                <a href="#">
                                    <span>
                                        <IconBrandInstagram stroke={1.4} size={25}/>
                                    </span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.facebook.com/p/MISU-LZR-Mobauto-61552707839982/">
                                    <span>
                                        <IconBrandFacebook stroke={1.4} size={24}/>
                                    </span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.emag.ro/misulxoa/180994/v?ref=see_vendor_page">
                                    <span>
                                        <IconShoppingCart stroke={1.3} size={22}/>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={`overlay ${isSidebarOpen ? 'active' : '' }`} onClick={() => setSidebarOpen(!isSidebarOpen)}></div>
            </div>
        </div>
    );
};

export default Header;